import { useState } from 'react';
import Stack from '@mui/joy/Stack';
// import Divider from '@mui/joy/Divider';
import Typography from '@mui/joy/Typography';

import CommentInput, { CommentSubmitProps } from 'components/CommentInput';
import { CollabProps } from 'stores/collab_store';
import useClock  from 'hooks/useClock';
import useUserIdentity from 'hooks/useUserIdentity';
import { LoreDecorator } from 'components/Lore';
import { FHRequestType } from 'stores/fhrequest_store';

import { MessageQAType } from 'stores/messages_store';
import useMessages from 'hooks/useMessages';
import useWorkKey from 'hooks/useWorkKey';

type InputProps = {
    uuid: string;
    onMessageSubmit: (comment: CommentSubmitProps) => boolean;
    clearId: string;
    collab?: CollabProps;
    request?: FHRequestType;
    associated_type: string;
    associated_uuid: string;
    onHeightChange?: (height: number) => void;
    onHide?: (hidden: boolean) => void;
    comment?: CommentSubmitProps | null;
};



export function AssistantInput({ associated_type, associated_uuid, uuid, onMessageSubmit, onHide, comment, clearId }: InputProps) {
    const { currentClock } = useClock();
    const workKey = useWorkKey();
    const { qa } = useMessages();
    const [qaResponse, setQaResponse] = useState<MessageQAType | null>(null);
    const [qaChecking, setQaChecking] = useState(false);
    const [useAI, setUseAI] = useState(false);

    var mustClockIn = true;

    //// If you created this collab, you definitely don't need to log in.
    // if(collab && (collab.identity === currentIdentity.key)) {
    //     mustClockIn = false;
    // }

    // we don't need to clock in for chats and non-collab/request messages
    if(!['collab', 'request'].includes(associated_type)) {
        console.log("No need to clock in\nNo need to clock in\nNo need to clock in\nNo need to clock in\n");
        mustClockIn = false;
    }

    // they must clock in
    if(mustClockIn) {
        // are they clocked in?
        if(currentClock && currentClock.key) {
            mustClockIn = (currentClock.associated_uuid != associated_uuid);
        }
    }

    function doMessageSubmit(comment: CommentSubmitProps) {
        setQaResponse(null);
        return onMessageSubmit(comment);
    }

    function onSubmit(comment: CommentSubmitProps) {
        if(associated_type == 'collab' && workKey) {
            if (comment.ignoreQA) {
                doMessageSubmit(comment);
            }
            else {
                if (useAI) {
                    // QA is disabled for now.
                    setQaChecking(true);
                    qa(workKey, associated_uuid, comment.content)
                        .then((data) => {
                            setQaChecking(false);
                            if (!data || (data && data.response_pass)) {
                                doMessageSubmit(comment);
                            }
                            if (data) {
                                setQaResponse(data);
                            }
                        });
                }
                // no AI, just send it
                else {
                    doMessageSubmit(comment);
                }
            }
        }
        else {
            doMessageSubmit(comment);
        }
        return true;
    }

    if(mustClockIn) {
        return (
            <Stack
                alignItems="center"
                mt={3}
                p={2}
            >
                <Typography
                    color="warning"
                    endDecorator={<LoreDecorator
                                      tooltipPlacement="top"
                                      slug="assistant/clock/overview" />}
                    sx={{ backgroundColor: "var(--BackgroundColor)" }}
                    level="body-md">
                    Clock in before responding.
                </Typography>
            </Stack>
        );
    }

    // if(onMessageSubmit) {
    return (
        <Stack>
            <CommentInput
                showAi={false} // associated_type == 'collab'}
                onAiEnabledChange={(enabled) => {
                    setUseAI(enabled);
                }}
                qaChecking={qaChecking}
                qaResponse={qaResponse}
                clearId={clearId}
                uuid={uuid}
                comment={comment}
                onHide={onHide}
                onSubmit={onSubmit} />
        </Stack>
    );
    //    }
    //    return null;
}

export default function CombinedInput( {
    collab,
    request,
    uuid,
    onMessageSubmit,
    onHide,
    comment,
    clearId,
    associated_type,
    associated_uuid,
} : InputProps) {

    const { currentIdentity } = useUserIdentity();

    // console.log("Combined input, collab: ", collab, " request: ", request);
    return (
        <Stack>

            {currentIdentity.role === 'client' &&
                <CommentInput
                    clearId={clearId}
                    uuid={uuid}
                    comment={comment}
                    onHide={onHide}
                    onSubmit={onMessageSubmit} />}

            {/* AssistantInput is only different in that it ensures
            you're clocked in to the right request/collab. */}
            {currentIdentity.role == 'assistant' &&
                <AssistantInput
                    clearId={clearId}
                    uuid={uuid}
                    comment={comment}
                    collab={collab}
                    request={request}
                    associated_type={associated_type}
                    associated_uuid={associated_uuid}
                    onHide={onHide}
                    onMessageSubmit={onMessageSubmit}
                />}
        </Stack>
    );

}
